import type { FC } from 'react';

interface DisplayYesOrNoProps {
  value?: boolean;
}

export const DisplayYesOrNo: FC<DisplayYesOrNoProps> = ({ value }) => {
  if (value === true) return <span data-testid="display-yes-or-no-yes">Yes</span>;
  if (value === false) return <span data-testid="display-yes-or-no-no">No</span>;
  return <span data-testid="display-yes-or-no-empty">-</span>;
};
